import { PLAYER_EVENT } from 'constants/events';

// https://gist.github.com/vankasteelj/74ab7793133f4b257ea3
export const secondsToTimecode = sec => {
    const time = parseFloat(sec).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60);

    return pad(minutes, 2) + ':' + pad(seconds, 2);

    function pad(num, size) {
        return ('000' + num).slice(size * -1);
    }
};

export const camelToSnakeCase = value => value.split(/([a-z]+)([A-z]+)/g).filter(f => f).join('_').toUpperCase();

export const camelToDashCase = value => value.split(/([a-z]+)|([A-z]+)/g).filter(f => f).join('-').toLowerCase();

export const capitalize = word => word.charAt(0).toUpperCase() + word.slice(1);

export const percent = (num, round = true) => round ? Math.round(num * 100) : num * 100;

export const objToBigQuery = (subject, key = 'key', val = 'value') => Object.keys(subject).map(k => ({ [key]: k, [val]: subject[k] }));

export const toQueryString = (obj = {}) => Object.keys(obj).length ? `&${new URLSearchParams(obj).toString()}` : '';

export const objToStyle = (obj = {}) => (
    Object
        .keys(obj)
        .map(key => `${key}: ${obj[key]}`)
        .join('; ')
);

export const objToAttributes = (obj = {}) => (
    Object
        .keys(obj)
        .map(key => {
            if (key === 'className') {
                return `class="${obj[key]}"`;
            } else if (key === 'style') {
                return `style="${objToStyle(obj[key])}"`;
            }

            return `${key}="${obj[key]}"`;
        })
        .join(' ')
);

export const stripUnit = (subject = '') => {
    const value = subject.replace(/(px|%|em|rem|vh|vw|vmax|vmin|ch|ex|cm|mm|in|pc|pt)/, ''),
        [,unit] = subject.split(value);

    return { value: Number(value), unit }
};